/* Marketplace shell: compact sticky header, bottom-nav cart count, mini-card quick add. */
(() => {
  /* ── Compact sticky header (mobile) ──────────────────────────────
     A sentinel covering the first 80px of the page drives the state, so
     there is no scroll listener. The header is moved with a transform and
     the hidden nav row is replaced by an equal margin, so page content
     never shifts when the state flips. */
  const header = document.querySelector('.section-header-marketplace');
  const sentinel = document.querySelector('[data-mk-sentinel]');

  if (header && sentinel && 'IntersectionObserver' in window) {
    const search = header.querySelector('.mkt-header__search-wrap');
    const nav = header.querySelector('.mkt-nav');

    const mobile = window.matchMedia('(max-width: 749px)');
    let full = 0;
    let collapseTop = 0;
    let collapseBottom = 0;

    // Publishes the height the sticky header currently covers, so other
    // sticky bars (collection filters) can sit directly beneath it.
    const publishHeight = () => {
      const sticky = getComputedStyle(header).position === 'sticky';
      const compact = mobile.matches && header.classList.contains('is-compact');
      const visible = sticky ? full - (compact ? collapseTop + collapseBottom : 0) : 0;
      document.documentElement.style.setProperty('--mk-header-visible', `${Math.max(0, visible)}px`);
    };

    const measure = () => {
      if (header.classList.contains('is-compact') || !search) return;
      const top = search.getBoundingClientRect().top - header.getBoundingClientRect().top - 8;
      collapseTop = Math.max(0, Math.round(top));
      collapseBottom = nav ? nav.offsetHeight : 0;
      full = header.offsetHeight;
      header.style.setProperty('--mk-collapse-top', `${collapseTop}px`);
      header.style.setProperty('--mk-collapse-bottom', `${collapseBottom}px`);
      publishHeight();
    };

    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);

    new IntersectionObserver(([entry]) => {
      const compact = !entry.isIntersecting;
      if (compact) {
        measure();
        const catnav = header.querySelector('category-nav');
        if (catnav && catnav.isOpen && mobile.matches) catnav.close();
      }
      header.classList.toggle('is-compact', compact);
      publishHeight();
    }).observe(sentinel);
  }

  /* ── Bottom-nav cart count ─────────────────────────────────────── */
  const setCount = (count) => {
    document.querySelectorAll('[data-mk-cart-count]').forEach((badge) => {
      badge.hidden = count === 0;
      const visible = badge.querySelector('[aria-hidden]');
      if (visible) visible.textContent = count < 100 ? count : '99+';
    });
  };

  const refreshCount = () =>
    fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => setCount(cart.item_count))
      .catch(() => {});

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }

  /* ── Mini-card quick add ───────────────────────────────────────── */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mk-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = {
      id: Number(button.dataset.mkAdd),
      quantity: Number(button.dataset.qty) || 1,
    };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement(button);
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    button.classList.remove('is-error');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          button.classList.add('is-error');
          button.title = response.description || response.message || '';
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'mk-quick-add',
              productVariantId: body.id,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'mk-quick-add',
            productVariantId: body.id,
            cartData: response,
          });
        } else {
          refreshCount();
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(() => button.classList.add('is-error'))
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
      });
  });
})();
